import React, { useState, useCallback, useEffect, useMemo } from "react";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  changeObjectPropertyAction,
  setAppProperty
} from "../../../../../redux/actions";
import {
  validateCityErrors,
  validatePostalCodeErrors,
  validateProvinceErrors,
  validateApartmentErrors,
  validateStreetNameErrors
} from "../../../../../shared/helpers/validators";
import {
  initialHomeAddress,
  initialMailingAddress
} from "../../../../../redux/reducers/appReducer";
import AddressAutoFill from "../../../../../shared/components/Address/AddressAutoFill";
import MailingAddressAutoFill from "../../../../../shared/components/Address/MailingAddressAutoFill";
import { HOUSE_OWN, HOUSE_RENT } from "../../../../../shared/const/data";

const country = "Canada";

const HomeAddressForm = ({
  t,
  setValidateForm,
  setIsError,
  setValidateMailingAddressForm,
  validHomeAddress,
  validMailingAddress,
  validMailingAddressSameDifferent
}) => {
  const MAILING_ADDRESS_REDUX_APP_PROPERTY = "mailingAddress";
  const HOME_ADDRESS_REDUX_APP_PROPERTY = "homeAddress";

  const dispatch = useDispatch();
  const [formErrors, setFormErrors] = useState({ ...initialHomeAddress });
  const [mailingFormErrors, setMailingFormErrors] = useState({
    ...initialMailingAddress
  });
  const homeAddress = useSelector((state) => state.app.homeAddress);
  const { streetAddress, city, apartment, postalCode, province } = homeAddress;
  const mailingAddress = useSelector((state) => state.app.mailingAddress);
  const { street } = mailingAddress;
  const [NSCAFAPIResponse, setNSCAFAPIResponse] = useState(null);
  const [canadaPostAPIResponse, setCanadaPostAPIResponse] = useState(null);
  const [streetAddressError, setStreetAddressError] = useState(
    "mailing_address.street_address_error"
  );
  const [mailingAddressValid, setMailingAddressValid] = useState("");
  const [mailingAddressError, setMailingAddressError] = useState(
    "mailing_address.mailing_address_error"
  );
  const [streetAddressValid, setStreetAddressValid] = useState("");
  const [cityValid, setCityValid] = useState("");
  const [cityError, setCityError] = useState("mailing_address.city_error");
  const [apartmentValid, setApartmentValid] = useState("");
  const [postalCodeValid, setPostalCodeValid] = useState("");
  const [postalCodeError, setPostalCodeError] = useState(
    "mailing_address.postal_code_error"
  );
  const [cityMailingValid, setCityMailingValid] = useState("");
  const [cityMailingError, setCityMailingError] = useState(
    "mailing_address.city_error"
  );
  const [postalCodeMailingValid, setPostalCodeMailingValid] = useState("");
  const [postalCodeMailingError, setPostalCodeMailingError] = useState(
    "mailing_address.postal_code_error"
  );
  const [apartmentError] = useState("mailing_address.apartment_error_invalid");
  const { mailingAddressSame, houseOwnOrRent } = useSelector(
    (state) => state?.app
  );
  const isMailingAddressSet = useMemo(() => {
    if (mailingAddressSame !== "") {
      return mailingAddressSame ? "same" : "different";
    }
    return "";
  }, [mailingAddressSame]);

  const [mailingAddressSameDifferent, setMailingAddressSameDifferent] =
    useState(isMailingAddressSet);

  const [
    mailingAddressSameDifferentError,
    setMailingAddressSameDifferentError
  ] = useState();
  const [ownOrRentError, setOwnOrRentError] = useState(false);

  const validateStreetAddress = (name, valid) => {
    try {
      //regex to test if name has both letters and numbers
      const regex = RegExp(/^(?=.*[a-zA-Z])(?=.*[0-9])/);


      // Step 2: Sanitize input
      const sanitizedInput = name.trim();
      if (valid === false) {
        setStreetAddressValid(false);
        setStreetAddressError("mailing_address.street_address_error");
      } else if (valid === null) {
        setStreetAddressValid("");
        setStreetAddressError("");
      } else {
        if (sanitizedInput.length > 0) {
          setStreetAddressValid(true);
        } else {
          setStreetAddressValid(false);
          setStreetAddressError("mailing_address.street_address_error");
        }
        // if (name.length > 0) {
        //   if (regex.test(sanitizedInput)) {
        //     setStreetAddressValid(true);
        //   } else {
        //     setStreetAddressValid(false);
        //     setStreetAddressError("mailing_address.street_address_error");
        //   }
        // } else {
        //   setStreetAddressValid(true);
        //   setStreetAddressError("mailing_address.street_address_error");
        // }
      }
    } catch (e) {
      console.log(e);
      setIsError(true);
    }
  };

  const validateMailingAddress = (name, valid) => {
    try {
      //regex to test if name has both letters and numbers
      const regex = RegExp(/^(?=.*[a-zA-Z])(?=.*[0-9])/);
      // Step 1: Limit input length
      const maxInputLength = 300;
      if (name.length > maxInputLength) {
        setMailingAddressValid(false);
        setMailingAddressError("mailing_address.mailing_address_error");
      }

      // Step 2: Sanitize input
      const sanitizedInput = name.trim();
      if (valid === false) {
        setMailingAddressValid(false);
        setMailingAddressError("mailing_address.mailing_address_error");
      } else if (valid === null) {
        setMailingAddressValid("");
        setMailingAddressError("");
      } else {
        if (name.length > 0) {
          // if (regex.test(sanitizedInput)) {
          setMailingAddressValid(true);
          //   } else {
          //     setMailingAddressValid(false);
          //     setMailingAddressError("mailing_address.mailing_address_error");
          //   }
          // } else {
          //   setMailingAddressValid(false);
          //   setMailingAddressError("mailing_address.mailing_address_error");
        }
      }
    } catch (e) {
      console.log(e);
      setIsError(true);
    }
  };

  const handleChangeObjectPropertyAction = useCallback(
    (fieldName, value) => {
      dispatch(
        changeObjectPropertyAction(
          HOME_ADDRESS_REDUX_APP_PROPERTY,
          fieldName,
          value
        )
      );
    },
    [dispatch, HOME_ADDRESS_REDUX_APP_PROPERTY]
  );

  const handleChangeMailingAddress = useCallback(
    (fieldName, value) => {
      dispatch(
        changeObjectPropertyAction(
          MAILING_ADDRESS_REDUX_APP_PROPERTY,
          fieldName,
          value
        )
      );
    },
    [dispatch, MAILING_ADDRESS_REDUX_APP_PROPERTY]
  );

  const validateCity = (cityName, required) => {
    try {
      // const regex = RegExp(
      //   /^[a-zA-Z0-9-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/
      // );
      const regex = RegExp(/[A-Za-zÀ-ȕ0-9(),\-_\.]/);
      if (required === false) {
        setCityValid(true);
      } else if (required === null) {
        setCityValid("");
        setCityError("");
      } else {
        if (cityName?.length > 0) {
          setCityValid(true);
        } else {
          setCityValid(false);
          setCityError("mailing_address.city_error");
        }
        // if (cityName?.length > 0) {
        //   if (regex.test(cityName)) {
        //   setCityValid(true);
        //   } else {
        //     setCityValid(false);
        //     setCityError(t("mailing_address.city_error"));
        //   }
        // } else {
        //   setCityValid(false);
        //   setCityError(t("mailing_address.city_error"));
        // }
      }
    } catch (e) {
      console.log(e);
      setIsError(true);
    }
  };

  const validateApartment = (name) => {
    setApartmentValid(true);
    return;
  };

  const validatePostalCode = (number, required) => {
    try {
      const regex = RegExp(/^[B]\d[A-Za-z][\- ]?\d[A-Za-z]\d$/i);
      if (required === false) {
        setPostalCodeValid(true);
      } else if (required === null) {
        setPostalCodeValid("");
        setPostalCodeError("");
      } else {
        if (regex.test(number)) {
          setPostalCodeValid(true);
        } else {
          setPostalCodeValid(false);
          setPostalCodeError("mailing_address.ns_postal_code_error");
        }
      }
    } catch (e) {
      console.log(e);
      setIsError(true);
    }
  };

  const validateMailingCity = (cityName, required) => {
    try {
      const regex = RegExp(
        /^[a-zA-Z0-9-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/
      );
      // Step 1: Limit input length
      const maxInputLength = 60;
      if (cityName?.length > maxInputLength) {
        setCityMailingValid(false);
        setCityMailingError(t("mailing_address.city_error"));
      }
      // Step 2: Sanitize input
      const sanitizedInput = cityName?.trim();
      if (required === false) {
        setCityMailingValid(true);
      } else if (required === null) {
        setCityMailingValid("");
        setCityMailingError("");
      } else {
        if (cityName?.length > 0) {
          if (regex.test(sanitizedInput)) {
            setCityMailingValid(true);
          } else {
            setCityMailingValid(false);
            setCityMailingError(t("mailing_address.city_error"));
          }
        } else {
          setCityMailingValid(false);
          setCityMailingError(t("mailing_address.city_error"));
        }
      }
    } catch (e) {
      console.log(e);
      setIsError(true);
    }
  };

  const validateMailingPostalCode = (number, required) => {
    try {
      const regex = RegExp(/^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/i);
      // Step 1: Limit input length
      const maxInputLength = 6;
      if (number?.length > maxInputLength) {
        setPostalCodeMailingValid(false);
        setPostalCodeMailingError("mailing_address.ns_postal_code_error");
      }

      // // Step 2: Sanitize input
      const sanitizedInput = number?.trim();
      if (required === false) {
        setPostalCodeMailingValid(true);
      } else if (required === null) {
        setPostalCodeMailingValid("");
        setPostalCodeMailingError("");
      } else {
        if (regex.test(sanitizedInput)) {
          setPostalCodeMailingValid(true);
        } else {
          setPostalCodeMailingValid(false);
          setPostalCodeMailingError("mailing_address.ns_postal_code_error");
        }
      }
    } catch (e) {
      console.log(e);
      setIsError(true);
    }
  };

  const validateFields = useCallback(() => {
    if (!houseOwnOrRent) {
      setOwnOrRentError(true);
    }
    let newFormErrors = { ...formErrors };
    newFormErrors.streetAddress = validateStreetNameErrors(streetAddress)
    if (validateStreetNameErrors(streetAddress)) {
      setStreetAddressError(validateStreetNameErrors(streetAddress))
      setStreetAddressValid(false)
    } else {
      setStreetAddressValid(true)
    }
    newFormErrors.postalCode = validatePostalCodeErrors(postalCode, country);
    if (validateCityErrors(city)) {
      setCityValid(false)
      setCityError(validateCityErrors(city))
    } else {
      setCityValid(true)
    }
    newFormErrors.city = validateCityErrors(city);
    newFormErrors.province = validateProvinceErrors(province);
    newFormErrors.apartment = validateApartmentErrors(apartment);
    setFormErrors(() => {
      return { ...newFormErrors };
    });
    const isValid = Object.values(newFormErrors).reduce(
      (prev, currentValue) => prev && !currentValue,
      true
    );

    const isFormClean = Object.values(newFormErrors).reduce(
      (prev, currentValue) => prev || currentValue === "",
      false
    );
    const newMailingAddress = { streetAddress, postalCode, province, city };

    return !isFormClean && isValid ? newMailingAddress : false;
  }, [
    formErrors,
    city,
    postalCode,
    apartment,
    streetAddress,
    province,
    houseOwnOrRent
  ]);

  const validateMailingFields = useCallback(() => {
    let newFormErrors = { ...mailingFormErrors };
    // if ((!street || street?.length < 3) && mailingAddress?.city !== null) {
    //   newFormErrors = { street: '' };
    //   newFormErrors.street = false;
    //   newFormErrors.postalCode = false;
    //   newFormErrors.city = false;
    //   newFormErrors.provinceState = false;
    // }
    if (street?.length > 3 && mailingAddress?.city === null) {
      newFormErrors = { street: "" };
      newFormErrors.street = validateStreetNameErrors(street);
      newFormErrors.postalCode = false;
      newFormErrors.city = false;
      newFormErrors.provinceState = false;
    } else {
      newFormErrors.street = validateStreetNameErrors(street);
      newFormErrors.postalCode = validatePostalCodeErrors(
        mailingAddress?.postalCode,
        "Canada"
      );
      newFormErrors.city = validateCityErrors(mailingAddress?.city);
      newFormErrors.provinceState = validateProvinceErrors(
        mailingAddress?.provinceState
      );
    }

    setMailingFormErrors(() => {
      return { ...newFormErrors };
    });
    const isValid = Object.values(newFormErrors).reduce(
      (prev, currentValue) => prev && !currentValue,
      true
    );
    const isFormClean = Object.values(newFormErrors).reduce(
      (prev, currentValue) => prev || currentValue === "",
      false
    );
    const newMailingAddress = { street };
    return !isFormClean && isValid ? newMailingAddress : false;
  }, [mailingFormErrors, street]);

  useEffect(() => {
    setValidateForm(() => validateFields);
  }, [setValidateForm, validateFields]);

  useEffect(() => {
    setValidateMailingAddressForm(() => validateMailingFields);
  }, [setValidateMailingAddressForm, validateMailingFields]);

  useEffect(() => {
    if (validHomeAddress === false || validHomeAddress === "false") {
      // setValidateForm(() => validateFields);
      if (NSCAFAPIResponse === false) {
        validateStreetAddress(streetAddress);
        // validateCity(city);
        validatePostalCode(postalCode?.replace(" ", "")?.toUpperCase());
      } else {
        validateStreetAddress(streetAddress);
        // validateCity(city);
        validatePostalCode(postalCode?.replace(" ", "")?.toUpperCase());
      }
    }
    if (validMailingAddressSameDifferent && validMailingAddress === false) {
      // setValidateMailingAddressForm(() => validateMailingFields);
      validateMailingAddress(street);
      if (canadaPostAPIResponse === false) {
        validateMailingAddress(street);
        validateMailingCity(mailingAddress?.city);
      } else {
        validateMailingAddress(street, false);
        validateMailingCity(mailingAddress?.city);
        validateMailingPostalCode(mailingAddress?.postalCode);
      }
    }
    // if (validMailingAddressSameDifferent === false) {
    //   setMailingAddressSameDifferentError(!validMailingAddressSameDifferent);
    // }

    if (validMailingAddressSameDifferent === false) {
      setMailingAddressSameDifferentError(!isMailingAddressSet);
    }

    // setValidateMailingAddressForm(() => validateMailingFields);
  }, [validHomeAddress, validMailingAddress, validMailingAddressSameDifferent, isMailingAddressSet]);

  return (
    <>
      <div className="row">
        <div className="col-xs-12">
          {HOME_ADDRESS_REDUX_APP_PROPERTY === "homeAddress" && (
            <>
              <div className="row">
                <AddressAutoFill
                  validateStreetAddress={validateStreetAddress}
                  streetAddressError={streetAddressError}
                  streetAddressValid={streetAddressValid}
                  setIsError={setIsError}
                  reduxAppProperty={HOME_ADDRESS_REDUX_APP_PROPERTY}
                  changeObjectPropertyAction={handleChangeObjectPropertyAction}
                  validateCity={validateCity}
                  validatePostalCode={validatePostalCode}
                  cityError={cityError}
                  cityValid={cityValid}
                  postalCodeError={postalCodeError}
                  postalCodeValid={postalCodeValid}
                  validateApartment={validateApartment}
                  apartmentError={apartmentError}
                  apartmentValid={apartmentValid}
                  setNSCAFAPIResponse={setNSCAFAPIResponse}
                />
              </div>
              <div>
                <div style={{ paddingBottom: "1.5em" }} className="row">
                  <div className="col-xs-12 col-md-12">
                    <div
                      className={
                        mailingAddressSameDifferentError
                          ? "ns-form-group has-error ns-form-group-message-error ns-label-wrapper"
                          : "ns-label-wrapper"
                      }
                    >
                      <label className="ns-label">
                        {t("home_information.same_address_label")}
                      </label>
                    </div>
                    {mailingAddressSameDifferentError && (
                      <div className="form-group has-error">
                        <div className="help-block">
                          <i
                            aria-label={t("errors.hidden_error_msg")}
                            className="fa fa-exclamation-circle error-indicator errorAlert"
                            aria-hidden="true"
                          />
                          <span className="ns-visually-hidden">
                            {t("errors.hidden_error_msg")}
                          </span>
                          <span style={{ marginLeft: "10px" }}>
                            {t("home_information.mailing_error")}
                          </span>
                        </div>
                      </div>
                    )}
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div
                        className="ns-radios__item"
                        onClick={() => {
                          setMailingAddressSameDifferentError(false);
                          setMailingAddressSameDifferent("same");
                          dispatch(setAppProperty("mailingAddressSame", true));
                        }}
                      >
                        <input
                          className="ns-radios__input"
                          type="radio"
                          id="same-mailing-address-radio"
                          name="same-mailing-address-radio"
                          value={"same"}
                          onChange={(e) => {
                            setMailingAddressSameDifferentError(false);
                            setMailingAddressSameDifferent(e.target.value);
                            dispatch(
                              setAppProperty("mailingAddressSame", true)
                            );

                            //Reset existing diffrent mailing address.
                            handleChangeMailingAddress("street", "");
                            handleChangeMailingAddress("city", "");
                            handleChangeMailingAddress("postalCode", "");
                          }}
                          checked={mailingAddressSameDifferent === "same"}
                        />
                        <label
                          className="ns-label ns-radios__label"
                          htmlFor="same-mailing-address-radio"
                          key="same-mailing-address-radio"
                        >
                          <span className="ns-label-span">
                            {t("home_information.same_address_radio")}{" "}
                          </span>
                        </label>
                      </div>
                      <div
                        className="ns-radios__item"
                        onClick={() => {
                          setMailingAddressSameDifferentError(false);
                          setMailingAddressSameDifferent("different");
                          dispatch(setAppProperty("mailingAddressSame", false));
                        }}
                      >
                        <input
                          className="ns-radios__input"
                          type="radio"
                          id="different-mailing-address-radio"
                          name="mailing-address-radio"
                          value={"different"}
                          onChange={(e) => {
                            setMailingAddressSameDifferentError(false);
                            setMailingAddressSameDifferent(e.target.value);
                            dispatch(
                              setAppProperty("mailingAddressSame", false)
                            );
                          }}
                          checked={mailingAddressSameDifferent === "different"}
                        />
                        <label
                          className="ns-label ns-radios__label"
                          htmlFor="mailing-address-radio"
                          key="different-mailing-address-radio"
                        >
                          <span className="ns-label-span">
                            {t("home_information.different_address_radio")}
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                {mailingAddressSameDifferent === "different" && (
                  <div
                    style={{ paddingBottom: "2em", paddingLeft: "1.5em" }}
                    className="row"
                  >
                    <div className="col-xs-12 col-sm-8">
                      <MailingAddressAutoFill
                        validateMailingAddress={validateMailingAddress}
                        mailingAddressError={mailingAddressError}
                        mailingAddressValid={mailingAddressValid}
                        setIsError={setIsError}
                        reduxAppProperty={MAILING_ADDRESS_REDUX_APP_PROPERTY}
                        changeObjectPropertyAction={handleChangeMailingAddress}
                        validateCity={validateMailingCity}
                        validatePostalCode={validateMailingPostalCode}
                        cityError={cityMailingError}
                        cityValid={cityMailingValid}
                        postalCodeError={postalCodeMailingError}
                        postalCodeValid={postalCodeMailingValid}
                        setCanadaPostAPIResponse={setCanadaPostAPIResponse}
                      />
                    </div>
                    {/* </div> */}
                  </div>
                )}

                <div style={{ paddingBottom: "1.5em" }} className="row">
                  <div className="col-xs-12 col-md-8">
                    <div
                      className={
                        ownOrRentError
                          ? "ns-form-group has-error ns-form-group-message-error ns-label-wrapper"
                          : "ns-label-wrapper"
                      }
                    >
                      <label className="ns-label">
                        {t("home_information.home_own_or_rent")}
                      </label>
                    </div>
                    {ownOrRentError && (
                      <div className="form-group has-error">
                        <div className="help-block">
                          <i
                            aria-label={t("errors.hidden_error_msg")}
                            className="fa fa-exclamation-circle error-indicator errorAlert"
                            aria-hidden="true"
                          />
                          <span className="ns-visually-hidden">
                            {t("errors.hidden_error_msg")}
                          </span>
                          <span style={{ marginLeft: "10px" }}>
                            {t("errors.own_rent_error")}
                          </span>
                        </div>
                      </div>
                    )}

                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div
                        className="ns-radios__item"
                        onClick={() => {
                          dispatch(setAppProperty("houseOwnOrRent", HOUSE_OWN));
                          setOwnOrRentError(false);
                        }}
                      >
                        <input
                          className="ns-radios__input"
                          type="radio"
                          id="house-own-radio"
                          name="house-own-radio"
                          value={HOUSE_OWN}
                          onChange={(e) => {
                            dispatch(
                              setAppProperty("houseOwnOrRent", HOUSE_OWN)
                            );
                          }}
                          checked={houseOwnOrRent === HOUSE_OWN}
                        />
                        <label
                          className="ns-label ns-radios__label"
                          htmlFor="house-own-radio"
                          key="house-own-radio"
                        >
                          <span className="ns-label-span">
                            {t("home_information.home_own")}
                          </span>
                        </label>
                      </div>
                      <div
                        className="ns-radios__item"
                        onClick={() => {
                          dispatch(
                            setAppProperty("houseOwnOrRent", HOUSE_RENT)
                          );
                          setOwnOrRentError(false);
                        }}
                      >
                        <input
                          className="ns-radios__input"
                          type="radio"
                          id="house-rent-radio"
                          name="house-rent-radio"
                          value={HOUSE_RENT}
                          onChange={(e) => {
                            dispatch(
                              setAppProperty("houseOwnOrRent", HOUSE_RENT)
                            );
                          }}
                          checked={houseOwnOrRent === HOUSE_RENT}
                        />
                        <label
                          className="ns-label ns-radios__label"
                          htmlFor="house-rent-radio"
                          key="house-rent-radio"
                        >
                          <span className="ns-label-span">
                            {t("home_information.home_rent")}
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default withTranslation("common")(HomeAddressForm);
